/*
 * NodeHeaderSettings Messages
 *
 * This contains all the text for the NodeHeaderSettings component.
 */
import { defineMessages } from 'react-intl';
import { SETTINGS_TOOLTIP_TYPES } from './constants';

export const scope = 'app.components.NodeHeaderSettings';

export default defineMessages({
  whenRespondentAnswers: {
    id: `${scope}.whenRespondentAnswers`,
    defaultMessage: 'When respondent answers',
  },
  beforeRespondentAnswers: {
    id: `${scope}.beforeRespondentAnswers`,
    defaultMessage: 'Before respondent answers',
  },
  duplicateDisabledDueToABTest: {
    id: `${scope}.duplicateDisabledDueToABTest`,
    defaultMessage:
      'You are only allowed to have one A/B Test per questionnaire',
  },
  duplicateDisabledDueToConjoint: {
    id: `${scope}.duplicateDisabledDueToConjoint`,
    defaultMessage:
      'You are only allowed to have one Conjoint per questionnaire',
  },
  duplicateDisabledDueToMaxDiff: {
    id: `${scope}.duplicateDisabledDueToMaxDiff`,
    defaultMessage:
      'You are only allowed to have one Maxdiff per questionnaire',
  },
  duplicateDisabledDueToConversationalAiLimitReached: {
    id: `${scope}.duplicateDisabledDueToConversationalAiLimitReached`,
    defaultMessage:
      'You are only allowed to have up to {limit} Conversational AI per questionnaire',
  },
  [SETTINGS_TOOLTIP_TYPES.COPY]: {
    id: `${scope}.${[SETTINGS_TOOLTIP_TYPES.COPY]}`,
    defaultMessage: 'Duplicate {entityName}',
  },
  [SETTINGS_TOOLTIP_TYPES.MOVE_UP]: {
    id: `${scope}.${[SETTINGS_TOOLTIP_TYPES.MOVE_UP]}`,
    defaultMessage: 'Move {entityName} up',
  },
  [SETTINGS_TOOLTIP_TYPES.MOVE_DOWN]: {
    id: `${scope}.${[SETTINGS_TOOLTIP_TYPES.MOVE_DOWN]}`,
    defaultMessage: 'Move {entityName} down',
  },
  [SETTINGS_TOOLTIP_TYPES.MOVE_MODAL]: {
    id: `${scope}.${[SETTINGS_TOOLTIP_TYPES.MOVE_MODAL]}`,
    defaultMessage: 'Move {entityName}',
  },
  [SETTINGS_TOOLTIP_TYPES.DELETE]: {
    id: `${scope}.delete`,
    defaultMessage: 'Remove {entityName}',
  },
  [SETTINGS_TOOLTIP_TYPES.RESTORE]: {
    id: `${scope}.restore`,
    defaultMessage: 'Restore {entityName}',
  },
  question: {
    id: `${scope}.question`,
    defaultMessage: 'question',
  },
  group: {
    id: `${scope}.group`,
    defaultMessage: 'group',
  },
  abTest: {
    id: `${scope}.abTest`,
    defaultMessage: 'A/B Test',
  },
  conjoint: {
    id: `${scope}.conjoint`,
    defaultMessage: 'Conjoint',
  },
  vanWestendorp: {
    id: `${scope}.vanWestendorp`,
    defaultMessage: 'PSM',
  },
  maxDiff: {
    id: `${scope}.maxDiff`,
    defaultMessage: 'Maxdiff',
  },
  disqualificationLogic: {
    id: `${scope}.disqualificationLogic`,
    defaultMessage: 'Disqualification Logic',
  },
});
